/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhPricing.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isCompareExpanded: true,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleToggleComparison = this.handleToggleComparison.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  handleToggleComparison() {
    this.setState((prevState) => ({
      isCompareExpanded: !prevState.isCompareExpanded,
    }));
  }

  render() {
    const { isCompareExpanded } = this.state;

    const PlanText = [
      {
        name: "free",
        displayName: "免費",
        price: "HK$0.00",
        description: (
          <>
            免費提供予所有
            <br />
            於香港註冊的慈善機構
          </>
        ),
        access: true,
        web: true,
        receipt: true,
        report: false,
        number: true,
        numberNote: "只限即時捐款",
        campaignDetails: null,
        creditCard: true,
        applePay: false,
        googlePay: false,
        recurringTransactions: false,
        PayMe: false,
        multipleLanguages: false,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: false,
        reducedTransactionFee: false,
        platformFee: "2%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#93C7EA",
        txtColor: "#93C7EA",
      },
      {
        name: "plus",
        displayName: "Plus",
        price: (
          <>
            HK$459/月
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              每月收費（按年收費）
            </span>
          </>
        ),
        description: "或 HK$550/月（按月收費）",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "最多 3 個",
        campaignDetails: "最多 3 個付款或捐款項目",
        creditCard: true,
        applePay: false,
        googlePay: false,
        recurringTransactions: false,
        PayMe: false,
        multipleLanguages: false,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#1390E3",
        txtColor: "#1390E3",
      },
      {
        name: "pro",
        displayName: "Pro",
        price: (
          <>
            HK$792/月
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              每月收費（按年收費）
            </span>
          </>
        ),
        description: "或 HK$950/月（按月收費）",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "最多 5 個",
        campaignDetails: "最多 5 個付款或捐款項目",
        creditCard: true,
        applePay: true,
        googlePay: true,
        recurringTransactions: true,
        PayMe: true,
        multipleLanguages: true,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#0969AA",
        txtColor: "#0969AA",
      },
      {
        name: "premium",
        displayName: "Premium",
        price: (
          <>
            HK$1,250/月
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              每月收費（按年結算）
            </span>
          </>
        ),
        description: "或 HK$1,500/月（按月收費）",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "無限",
        campaignDetails: "無上限付款或捐款項目",
        creditCard: true,
        applePay: true,
        googlePay: true,
        recurringTransactions: true,
        PayMe: true,
        multipleLanguages: true,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1% 或 0.5%*",
        manualPayments: true,
        customDomain: true,
        customInputFields: true,
        bgColor:
          "linear-gradient(45deg, rgba(162,248,255,1) 0%, rgba(0,88,149,1) 100%)",
        txtColor: "#52A9CB",
      },
    ];

    const PLATFORM_FEE_DISCLAIMER =
      "*如過去 12 個月的交易額超過 HK$400,000";

    const featureCellStyle = {
      display: "flex",
      height: "75px",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    };

    const featureLabelItemStyle = {
      height: "75px",
      justifyContent: "end",
      alignItems: "center",
      color: "black",
      textAlign: "left",
      fontSize: "10pt",
    };

    const renderCheckIcon = (enabled) =>
      enabled ? (
        <div className="ZhPricing-confirmFeature" alt="Confirm" />
      ) : (
        <div className="ZhPricing-crossFeature" alt="Cross" />
      );

    const getPlanDisplayName = (plan) => plan.displayName;

    const compareRows = [
      {
        key: "plans",
        label: "方案",
        render: (plan) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              className="ZhPricing-planDot"
              style={{
                background: plan.bgColor,
              }}
            />
            <div
              className="ZhPricing-planTxt"
              style={{
                color: plan.txtColor,
                fontWeight: "600",
              }}
            >
              {getPlanDisplayName(plan)}
            </div>
          </div>
        ),
      },
      {
        key: "verified-nonprofit",
        label:
          "列入 CheckPlus 已認證慈善團體名單 (更多專屬優惠即將推出!)",
        render: (plan) => renderCheckIcon(plan.verifiedNonprofit),
      },
      {
        key: "org-dashboard",
        label: "機構管理平台",
        render: (plan) => renderCheckIcon(plan.access),
      },
      {
        key: "items",
        label: "項目數量",
        render: (plan) =>
          plan.number ? (
            <div className="ZhPricing-numberNote">{plan.numberNote}</div>
          ) : (
            renderCheckIcon(false)
          ),
      },
      {
        key: "automated-receipts",
        label: "自動發送付款及捐款收據",
        render: (plan) => renderCheckIcon(plan.receipt),
      },
      {
        key: "cover-fees",
        label: "捐款者可選擇代付交易手續費",
        render: (plan) => renderCheckIcon(plan.coverFees),
      },
      {
        key: "landing-page",
        label: "建立捐款網頁",
        render: (plan) => renderCheckIcon(plan.web),
      },
      {
        key: "landing-customisation",
        label: "自訂捐款網頁設計",
        render: (plan) => renderCheckIcon(plan.landingPageCustomization),
      },
      {
        key: "system-report",
        label: "建立平台報告",
        render: (plan) => renderCheckIcon(plan.report),
      },
      {
        key: "multiple-languages",
        label: "多種語言",
        render: (plan) => renderCheckIcon(plan.multipleLanguages),
      },
      {
        key: "recurring",
        label: "每月定期交易",
        render: (plan) => renderCheckIcon(plan.recurringTransactions),
      },
      {
        key: "manual-payments",
        label: "手動支付（例如支票、八達通、現金等",
        render: (plan) => renderCheckIcon(plan.manualPayments),
      },
      {
        key: "custom-domains",
        label: "專屬網域與電郵地址",
        render: (plan) => renderCheckIcon(plan.customDomain),
      },
      {
        key: "custom-inputs",
        label: "自訂表格問題",
        render: (plan) => renderCheckIcon(plan.customInputFields),
      },
      {
        key: "payment-methods",
        label: "付款方式",
        isSectionHeader: true,
        render: () => null,
      },
      {
        key: "credit-card",
        label: "信用卡（透過 Stripe）Visa、Mastercard、AMEX、銀聯",
        render: (plan) => renderCheckIcon(plan.creditCard),
      },
      {
        key: "reduced-card-fee",
        label: "信用卡交易手續費減免",
        render: (plan) => renderCheckIcon(plan.reducedTransactionFee),
      },
      {
        key: "apple-pay",
        label: "Apple Pay",
        render: (plan) => renderCheckIcon(plan.applePay),
      },
      {
        key: "google-pay",
        label: "Google Pay",
        render: (plan) => renderCheckIcon(plan.googlePay),
      },
      {
        key: "payme",
        label: "PayMe",
        render: (plan) => renderCheckIcon(plan.PayMe),
      },
      {
        key: "platform-fee",
        label: "平台費",
        render: (plan) =>
          plan.platformFee ? (
            <div className="ZhPricing-numberNote" style={{ textAlign: "center" }}>
              {plan.platformFee}
            </div>
          ) : (
            renderCheckIcon(false)
          ),
      },
    ];

    const renderPlanCell = (row, plan) =>
      row.isSectionHeader ? null : row.render(plan);

    const renderComparisonTable = (plans) => (
      <div className="ZhPricing-featureContainer2">
        <div className="ZhPricing-featureSet">
          {compareRows.map((row) => (
            <div
              style={{
                ...featureLabelItemStyle,
                fontWeight: row.isSectionHeader ? "600" : undefined,
              }}
              key={row.key}
            >
              <div
                className="ZhPricing-featureText"
                style={row.isSectionHeader ? { textTransform: "uppercase" } : {}}
              >
                {row.label}
              </div>
            </div>
          ))}
        </div>

        {plans.map((plan, index) => (
          <div key={`${plan.name}-${index}`}>
            <div className="ZhPricing-featureDescriptionRowBottom">
              {compareRows.map((row) => (
                <div style={featureCellStyle} key={row.key}>
                  {renderPlanCell(row, plan)}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );

    return (
      <div className="ZhPricing-view">
        <Helmet>
          <title>訂閱計劃 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhPricing-first">
          <div className="ZhPricing-mainContainer">
            <div className="ZhPricing-topContainer">
              <div className="ZhPricing-heading">
                讓您的非牟利機構更加高效，
                <br />
                您就可以做更有意義的事情。
              </div>

              <div className="ZhPricing-comingSoon">
                <div className="ZhPricing-comingText">全新訂閱方案</div>
              </div>
            </div>

            <div className="ZhPricing-featureContainer">
              <div className="ZhPricing-extraSpace"></div>

              {PlanText.map((plan, key) => (
                <div
                  className="ZhPricing-featureDescriptionColumn"
                  key={key}
                  style={{
                    position: "relative",
                    minHeight: "600px",
                    paddingBottom: "200px",
                    marginTop: "30px",
                    marginBottom: "30px",
                  }}
                >
                  <div
                    className="ZhPricing-featureDescriptionRowTop"
                    style={{
                      background: plan.bgColor,
                    }}
                  >
                    <div className="ZhPricing-planContainer">
                      <div className="ZhPricing-planName">{plan.displayName}</div>

                      <div className="ZhPricing-planPrice">{plan.price}</div>

                      <div className="ZhPricing-planDescription">
                        {plan.description}
                      </div>
                    </div>
                  </div>
                  <div className="ZhPricing-featureContainerRowBottom">
                    <Link to="/OrgSignup">
                      <div
                        className="ZhPricing-getStarted"
                        style={{
                          background: plan.bgColor,
                        }}
                      >
                        立即申請
                      </div>
                    </Link>

                    {plan.name === "plus" ? (
                      <div className="ZhPricing-everythingPlus">
                        包含「免費」方案的所有功能及以下新增功能。
                      </div>
                    ) : null}

                    {plan.name === "pro" ? (
                      <div className="ZhPricing-everythingPlus">
                        包含「Plus」方案的所有功能及以下新增功能。
                      </div>
                    ) : null}

                    {plan.name === "premium" ? (
                      <div className="ZhPricing-everythingPlus">
                        包含 Pro 方案的所有功能及以下新增功能。
                      </div>
                    ) : null}

                    {plan.name === "free" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          建立網上帳戶
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          建立付款和捐款網頁
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          收取付款和捐款
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          自動發送付款及捐款收據
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          支援以下由 Stripe 提供的付款方式
                          <p />

                          <strong>主要信用卡網絡</strong>
                          <br />
                          - Visa
                          <br />
                          - MasterCard
                          <br />
                          - American Express
                          <br />
                          - UnionPay
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          捐款者可選擇代付交易手續費
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                  

                    {plan.campaignDetails ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          {plan.campaignDetails}
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "pro" && plan.recurringTransactions ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          每月定期付款和捐款
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.report && plan.name === "plus" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          建立平台報告
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "plus" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                          自訂付款和捐款網頁設計
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.reducedTransactionFee && plan.name === "plus" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">更優惠平台費用</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.applePay && plan.name !== "premium" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">Apple Pay</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.googlePay && plan.name !== "premium" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">Google Pay</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.recurringTransactions && plan.name === "plus" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">每月定期付款和捐款</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.PayMe && plan.name !== "premium" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">PayMe</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.multipleLanguages && plan.name !== "premium" ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">多種語言</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.customDomain ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">專屬網域與電郵</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.manualPayments ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">
                        手動支付處理 (如八達通、現金等，無交易手續費) 
                        
                        
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.customInputFields ? (
                      <div className="ZhPricing-paymeFeature">
                        <div
                          className="ZhPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="ZhPricing-featureTxt">自訂表格問題</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    <div
                      style={{
                        background: "white",
                        border: `2px solid ${plan.txtColor}`,
                        borderRadius: "15px",
                        padding: "20px",
                        textAlign: "center",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        width: "300px",
                        boxSizing: "border-box",
                        position: "absolute",
                        top: "710px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14pt",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "8px",
                        }}
                      >
                        平台費
                      </div>
                      <div
                        style={{
                          fontSize: "18pt",
                          fontWeight: "700",
                          color: plan.txtColor,
                        }}
                      >
                        {plan.platformFee}
                      </div>

                      {plan.name === "premium" ? (
                        <div
                          style={{
                            marginTop: "12px",
                            fontSize: "10pt",
                            fontWeight: "400",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          {PLATFORM_FEE_DISCLAIMER}
                        </div>
                      ) : null}

                      <div
                        style={{
                          marginTop: "15px",
                          paddingTop: "15px",
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12pt",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "5px",
                          }}
                        >
                          交易手續費：
                        </div>
                        <div
                          style={{
                            fontSize: "11pt",
                            fontWeight: "400",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          由支付平台收取
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="ZhPricing-extraSpace"></div>
            </div>

            <div className="ZhPricing-topColumnRight"></div>

            <button
              type="button"
              className="ZhPricing-compareButton"
              onClick={this.handleToggleComparison}
            >
              {isCompareExpanded ? "隱藏比較" : "比較所有計劃"}
            </button>

            {isCompareExpanded && (
              <>
                {renderComparisonTable(PlanText)}

                <div
                  style={{
                    marginTop: "0px",
                    fontSize: "10pt",
                    color: "#666",
                    fontStyle: "italic",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: "50px",
                  }}
                >
                  {PLATFORM_FEE_DISCLAIMER}
                </div>
              </>
            )}

            <div className="ZhPricing-TransactionFeeContainer">
              <h1>交易手續費</h1>
            </div>

            <div className="ZhPricing-gridBGTransactionFee">
              <div className="ZhPricing-stripePaidContainer">
                <div className="ZhPricing-hsbc">
                  <div className="ZhPricing-stripeLogo" />
                  <div className="ZhPricing-bar" />
                  <div className="ZhPricing-hsbcDescription">交易手續費</div>
                </div>

                <div className="ZhPricing-hsbcText">
                  <strong>本地 Visa/Mastercard</strong>
                  <br />
                  2.9% + HK$2.35

                  <p />
                  <strong>
                    本地 American Express
                  </strong>
                  <br />
                  3.4% + HK$2.35
                  <p />
                  <strong>所有國際卡</strong>
                  <br />
                  + 0.5% 國際卡
                </div>
              </div>
              <div className="ZhPricing-hsbcContainer">
                <div className="ZhPricing-hsbc">
                  <div className="ZhPricing-hsbcLogo" />
                  <div className="ZhPricing-bar" />
                  <div className="ZhPricing-hsbcDescription">交易手續費</div>
                </div>

                <div className="ZhPricing-hsbcText">
                  <strong>PayMe for Business</strong>
                  <br />
                  1.5%
                  <br />
                  費用由香港滙豐銀行決定
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ZhPricing-referralContainer">
          <div className="ZhPricing-referralWidth">
            <div className="ZhPricing-heading">推薦計劃</div>

            <div className="ZhPricing-comingSoon">
              <div className="ZhPricing-comingText">即將推出</div>
            </div>

            <div className="ZhPricing-subHeading">
              每成功推薦 1 間機構即可獲得 1 個月費用豁免*
              <p />
              <div className="ZhPricing-subtitle">
                *請注意，當您推薦的非牟利機構成功註冊服務後，您方可獲得 1 個月費用豁免。推薦數量不限。
              </div>
            </div>
          </div>
        </div>

        <div className="ZhPricing-footer">
          <div className="ZhPricing-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhPricing-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhPricing-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhPricing-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhPricing-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhPricing-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhPricing-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhPricing;
